"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("@indigenux/design/components");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const PageHeader = _ref => {
  let {
    Category,
    borderClass = "bg-primary",
    children
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
    className: "page-header page-header-classic",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "row",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "col",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
            className: "breadcrumb",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
                href: "/",
                children: "Home"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
              className: "active text-color-light",
              children: Category
            })]
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "row",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "col p-static",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "page-header-title-border visible " + borderClass,
            style: {
              width: '400px'
            }
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Heading, {
            level: "h1",
            "data-title-border": true,
            children: children
          })]
        })
      })]
    })
  });
};
PageHeader.defaultProps = {};
var _default = exports.default = PageHeader;